import React,{useState,useEffect,useRef} from "react";
import { Parallax, ParallaxProvider } from "react-scroll-parallax"; 
import { Swiper, SwiperSlide } from "swiper/react"; 
import "swiper/css";  
import { motion } from "framer-motion";
import { Navigation} from "swiper/modules";
import { useInView } from "react-intersection-observer";

const ParallaxSection = () => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
          setIsImageLoaded(true);
        }, 1000); 
        return () => clearTimeout(timer); 
      }, []);
      const handleSlideChange = () => {
        setIsImageLoaded(false);
        setTimeout(() => {
          setIsImageLoaded(true);
        },100);
      };
      const { ref: slide1, inView: slide1InView } = useInView({
          triggerOnce: false, 
          threshold: 0.5, 
        });
        const { ref: slide2, inView: slide2InView } = useInView({
            triggerOnce: false, 
            threshold: 0.5, 
          });
        //   const { ref: slide3, inView: slide3InView } = useInView({
        //       triggerOnce: false, // Trigger the animation once when it comes into view
        //       threshold: 0.5, // Start when 50% of the element is in view
        //     });
        //     const { ref: slide4, inView: slide4InView } = useInView({
        //       triggerOnce: false, 
        //       threshold: 0.5, 
        //     });
        //     const { ref: slide5, inView: slide5InView } = useInView({
        //       triggerOnce: false, 
        //       threshold: 0.5, 
        //     });
  return (
    <ParallaxProvider>
    <div className="App">
      <Parallax speed={-45}>
      <section className="h-screen bg-cover bg-white bg-center relative">
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              speed={1500}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              modules={[Navigation]} // Navigation module
              className="h-full"
              navigation={{
                nextEl: ".swiper-button-prev",
                prevEl: ".swiper-button-next",
              }}
              onSlideChange={handleSlideChange}
            >
               <SwiperSlide>
                <div className={`h-full relative ${isImageLoaded ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
                  {/* <video
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source
                      src="../video3.mp4" // Replace with your video URL
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video> */}
                  <img src="../landing.jpg" className="absolute top-0 left-0 w-full h-full object-cover"/>
                    <motion.div
                      className="absolute bottom-16 md:bottom-5 md:left-10 text-white"
                      
                      ref={slide1}
                    >
                     <div className="text-4xl  p-5 mb-8 rounded font-bold">
                         
                              <h1 className="md:text-8xl font-bold text-yellow-600 font-serif mb-4">SpanBucks</h1>
                              <p className="text-2xl font-serif mb-8">
                              Ultimate Destination for Real Estate Solutions
                              </p>
                      </div>        
                    </motion.div>
                  
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={`h-full relative ${isImageLoaded ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
                  {/* <video
                    className="absolute top-0 left-0 w-full h-full sm:object-contain md:object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source
                      src="../Software_solutions.mp4" // Replace with your video URL
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video> */}
                    <img src="../slide2.jpg" className="absolute top-0 left-0 w-full h-full object-cover"/>
                  <motion.div
                    className="absolute bottom-16 md:bottom-5 md:left-10 text-white"
                    ref={slide2}
                  >
                      <div className="text-4xl  p-5 mb-8 rounded font-bold" >
                          <h1 className="md:text-8xl font-bold  text-yellow-600 font-serif mb-4">Hilltop Villas</h1>
                          <p className="text-2xl font-serif mb-8">
                          Wake Up to Misty Mornings and Majestic Views.
                          </p>
                      </div>                        
                  </motion.div>
                </div>
              </SwiperSlide>
              {/*<SwiperSlide>
                <div className={`h-full relative ${isImageLoaded ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
                  <video
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source
                      src="../smartcity1.mp4" // Replace with your video URL
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>

                  <motion.div
                    className="absolute bottom-16 md:left-10 text-white"
                    initial={{ opacity: 0, y: 200 }} // Initial position off-screen (below)
                    animate={{ opacity: slide3InView ? 1 : 0, y: slide3InView ? 0 : 50, }} // Slide up to normal position
                    transition={{ duration: 1,delay:1 }}
                    ref={slide3}
                  >
                      <Parallax className="text-4xl font-bold" translateY={[50, -250]}>
                          <h1 className="md:text-8xl font-bold font-serif mb-4">Smart Cities Solutions</h1>
                          <p className="text-2xl font-serif mb-8">
                          Building Smarter Communities for a Greener Future
                          </p>
                      </Parallax>                        
                  </motion.div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className={`h-full relative ${isImageLoaded ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}>
                  <video
                    className={`absolute top-0 left-0 w-full h-full object-cover ${isImageLoaded ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source
                      src="../drone.mp4" // Replace with your video URL
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>

                  <motion.div
                    className="absolute bottom-16 md:left-10 text-white"
                    initial={{ opacity: 0, y: 200 }} // Initial position off-screen (below)
                    animate={{ opacity: slide4InView ? 1 : 0, y: slide4InView ? 0 : 50, }} // Slide up to normal position
                    transition={{ duration: 1, delay:1 }}
                    ref={slide4}
                  >
                     <Parallax className="text-4xl font-bold" translateY={[50, -250]}>

                          <h1 className="md:text-8xl font-bold  font-serif mb-4">Drone Survilence Solution</h1>
                          <p className="text-2xl font-serif mb-8">
                            Embrace the future with innovative tech solutions to elevate your business.
                          </p>
                          
                   </Parallax>
                  </motion.div>
                </div>
              </SwiperSlide> */}
            </Swiper>

            
            <div className="absolute z-50 bottom-10 right-20 flex gap-4">
           <button className="swiper-button-prev carousel-nav left">
                
                <svg viewBox="0 0 24 24">
                  <path d="M8.59 16.59L13.17 12l-4.58-4.59L10 6l6 6-6 6z" />
                </svg>
              </button>
              <button className="swiper-button-next carousel-nav right">
              <svg viewBox="0 0 24 24">
                  <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z" />
                </svg>
              </button>
              
            </div> 
             
            
          </section>
      </Parallax>

          </div>
  </ParallaxProvider>

  );
};

export default ParallaxSection;
